import { APIPropertyFunction, APIPropertyItemFunction } from '@mygpt/app/functions/services/list';
import { Http } from '@mygpt/app/http';

export interface AddApiParams extends APIPropertyFunction {
  // 数据集 ID
  datasetId: string;
}

/**
 * 添加API
 * @param params
 * @returns
 */
export const addApiService = (params: AddApiParams) => {
  const { datasetId, ...rest } = params;
  const { post } = Http.use();
  rest.header_authorization = rest.header_authorization || '{}';
  return post<APIPropertyItemFunction>(`/datasets/${datasetId}/functions`, rest);
};
